import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { MonitoringMessageType, MonitoringStatsType } from "../../shared/types/monitoring";

import { createReplaceAllReducer } from "store/utils";

const defaultState: MonitoringStatsType = {
  stats: {},
};

const initialState = () => defaultState;

export const MonitoringStore = createSlice({
  name: "monitoring",
  initialState,
  reducers: {
    setMonitoringStats: (state, action: PayloadAction<MonitoringStatsType>) => {
      state.stats = action.payload.stats;
    },
    updateMonitoringStats: (state, action: PayloadAction<MonitoringMessageType>) => {
      const { courseId, eventType, data } = action.payload;
      if (!state.stats[courseId]) {
        state.stats[courseId] = {};
      }
      state.stats[courseId][eventType] = data;
    },
  },
  extraReducers: createReplaceAllReducer<MonitoringStatsType>("monitoring", initialState),
});

export const monitoringStateActions = MonitoringStore.actions;
